











import { defineComponent, PropType, ref } from '@vue/composition-api'
import Comment from '@/classes/Comment'
import { useIntersectionObserver } from '@vueuse/core'
import Store from '@/classes/Store'

export default defineComponent({
  props: {
    store: {
      type: Object as PropType<Store>,
      required: true,
    },
    list: {
      type: Array as PropType<Comment[]>,
      default: [],
    },
    isFetching: {
      type: Boolean,
      default: false,
    },
    isAllLoaded: {
      type: Boolean,
      default: false,
    },
  },
  setup (props, { emit }) {
    const loadMore = () => {
      emit('load-more')
    }

    // 列表尾端的元素
    const end = ref<Element>()
    useIntersectionObserver(end, () => {
      if (!props.isAllLoaded) loadMore()
    }, { threshold: 0 })

    return {
      end,
      loadMore,
    }
  },
})
